import { Button, Container, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import confirmIcon from 'assets/images/modal-confirm-questionMark.svg'

function CancelModal({ show, onHide, title, handleCancel, ...otherProps }) {
	const { t } = useTranslation()

	return (
		<BaseModal show={show} onHide={onHide} hideDecor={true} {...otherProps}>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Header>
					<img src={confirmIcon} alt="" />
				</Modal.Header>
				<Modal.Body>
					<p
						className="text-center"
						style={{
							fontWeight: 500,
							fontSize: '17px',
							lineHeight: '24px',
							color: '#B1B5C3',
						}}
					>
						{title}
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="dark" onClick={onHide}>
						{t('modal.btn.cancel')}
					</Button>
					<Button variant="secondary" onClick={handleCancel}>
						{t('modal.btn.agree')}
					</Button>
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}

export default CancelModal
